var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"772845a36bdf383feaafbb5ffe763fb7f3e56208"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["bridge128@bridge128-96"]={id:"772845a36bdf383feaafbb5ffe763fb7f3e56208"};
      